module.exports = __webpack_public_path__ + "../resources/img/visual_img1.05dbf3c9.png";